export type CoverImageTransformationType = 'none' | 'contain' | 'stretch';
export type CoverImageContainType = 'standard' | 'dominantBackgroundColor' | 'ai';
export type CloudinaryTransformationParamType =
	| 'c_fill,q_auto,'
	| 'noCloudinaryTransformation'
	| 'b_gen_fill,c_pad,'
	| 'b_auto:predominant_gradient:2:diagonal_desc,c_pad,'
	| 'c_pad,q_auto,';

export const constructCloudinaryTransformationParam = (
	coverImageTransformationType: CoverImageTransformationType,
	coverImageContainType: CoverImageContainType
): CloudinaryTransformationParamType => {
	let str: CloudinaryTransformationParamType;

	if (coverImageTransformationType == 'stretch') {
		str = 'c_fill,q_auto,';
	} else if (coverImageTransformationType == 'none') {
		str = 'noCloudinaryTransformation';
	} else if (coverImageTransformationType == 'contain') {
		switch (coverImageContainType) {
			case 'ai':
				str = 'b_gen_fill,c_pad,';
				break;
			case 'dominantBackgroundColor':
				str = 'b_auto:predominant_gradient:2:diagonal_desc,c_pad,';
				break;
			case 'standard':
				str = 'c_pad,q_auto,';
				break;
			default:
				str = 'c_pad,q_auto,';
		}
	} else {
		str = 'c_fill,q_auto,';
	}
	return str;
};
